import React, { Component } from "react";
import itunesLogo from "../../assets/img/pictures/i-tunes-logo.png";
import memoryLogo from "../../assets/img/pictures/memory-logo.png";
import tnwLogo from "../../assets/img/pictures/tnw-logo.png";


class HomeAsSeenIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      region: props.region,
      exam: props.exam,
    }
  }

  render() {
    return (
      <section className="as-seen-in">
        <div className="container">
          <h2>As seen in</h2>
          <div className="row">
            <div className="col-sm-12">
              <div className="icons">
                <div>
                  <img src={itunesLogo} alt="" />
                </div>
                <div>
                  <img src={memoryLogo} alt="" />
                </div>
                <div>
                  <img src={tnwLogo} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
export default HomeAsSeenIn;
